import Styles from '@/CMS/editor/components/Styles'

const getBreakpointWidths = (numColumns) => { // number || { md: number, sm: number, xs: number }
	const cols = numColumns && typeof numColumns === 'object'
		? numColumns
		: {
			md: numColumns || 1,
			sm: numColumns > 1 ? Math.round(numColumns / 2) : 1,
			xs: 1,
		}
	return {
		widthMd: (100 / cols.md).toFixed(3).slice(0, -1),
		widthSm: (100 / cols.sm).toFixed(3).slice(0, -1),
		widthXs: (100 / cols.xs).toFixed(3).slice(0, -1),
	}
}

export const CmsGroupViewMixin = {
	data () {
		return {
			dataName: 'contentData', // override this in component
		}
	},
	methods: {
		getItemWidth (numColumns) { // number || { md: number, sm: number, xs: number }
			const { widthMd, widthSm, widthXs } = getBreakpointWidths(numColumns)
			return this.$vuetify.breakpoint.xsOnly ? widthXs : (this.$vuetify.breakpoint.mdAndUp ? widthMd : widthSm)
		},
	},
	computed: {
		itemsStyle () {
			const width = this.getItemWidth(this[this.dataName].NumColumns)
			return {
				'--col-width': `${width}%`,
			}
		},
    },
}

export const CmsGroupEditorMixin = {
	data () {
		return {
			itemsName: '', // override this in component
			numColumnsTooltip: 'Number of Columns for computer screens. The value must be an integer between 1 and 12.</br> <strong>Note:</strong> For tablet screens, the number of columns is halved. For mobile screens, the number of columns is 1.',
			available_colors: Styles.Backgrounds,
            counter: Math.floor(Math.random() * 1000000000),
		}
	},
	created () {
        this.reset()
    },
    computed: {
		mValue: {
			get () { return this.value },
			set (val) { this.$emit('input', val) },
		},
		itemsStyle () {
			const width = this.getItemWidth(this.mValue?.NumColumns)
			return {
				'--col-width': `${width}%`,
			}
		},
    },
    methods: {
		reset () {}, // override this in component
		getNewItem () { // override this in component
			return {}
		},
		getItemWidth (numColumns) { // number || { md: number, sm: number, xs: number }
			const { widthMd, widthSm, widthXs } = getBreakpointWidths(numColumns)
			return this.$vuetify.breakpoint.xsOnly ? widthXs : (this.$vuetify.breakpoint.mdAndUp ? widthMd : widthSm)
		},
		deleteItem (idx) {
			if (!this.itemsName) { return }
			this.mValue[this.itemsName] = [
				...this.mValue[this.itemsName].slice(0, idx),
				...this.mValue[this.itemsName].slice(idx + 1),
			]
        },
		addItem () {
			if (!this.itemsName) { return }
			this.mValue[this.itemsName] = [
				...this.mValue[this.itemsName],
				this.getNewItem(),
			]
        },
    },
}
